/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "antd";
import { TableRecordProps } from "../../ducks/types";

interface PropsType {
  proposal: any;
  setTableRecord: React.Dispatch<React.SetStateAction<TableRecordProps | null>>;
  handleCardStatusChange: (
    status: string,
    proposalId: string,
    hasDocument?: boolean | undefined
  ) => void;
}

export default function PendingApproval(props: PropsType) {
  const { proposal, handleCardStatusChange, setTableRecord } = props;
  return (
    <div
      className="status_card"
      style={{ border: "1px solid #F6EAFF", backgroundColor: "#F6EAFF66" }}
    >
      <div className="titleBar">
        <img src="/images/potential-deals/status/pending_approval.svg" alt="" />
        <Button
          htmlType="button"
          className="blue-btn btn-sm"
          type="primary"
          onClick={() => {
            handleCardStatusChange("ready", proposal.id, proposal?.document);
            setTableRecord(proposal);
          }}
          style={{ backgroundColor: "#943AF5" }}
        >
          Approve
        </Button>
      </div>
      <h5>
        Status:{" "}
        <span style={{ color: "#943AF5", fontWeight: "700" }}>
          Pending approval
        </span>
      </h5>
      {/* <h6
        style={{
          fontSize: "14px",
          lineHeight: "20px",
          fontWeight: "400",
        }}
      >
        {" "}
        Awaiting approval from Bryan Jones.{" "}
      </h6> */}
    </div>
  );
}
